import React from 'react';
import classnames from 'classnames';
import TabContent from './TabContent';
import TabTitle from './TabTitle';
import PropTypes from 'prop-types';

class TabbedPanel extends React.Component {
    constructor(props) {
        super(props);

        const {
            tabTitles,
            tabPanels,
            activeTabPosition = 0
        } = props;

        if (tabTitles.length !== tabPanels.length) {
            throw new Error("The number of titles must be equal to the number of panels");
        }

        this.state = {
            activeTabPosition
        };
    }

    setTabActive = titleIndex  => {
        const { tabTitles } = this.props;

        this.setState({
            activeTabPosition: titleIndex >= tabTitles.length ? 0 : titleIndex
        });
    }

    render() {
        const {
            tabTitles,
            tabPanels,
            tabTitleTextAlignment = "left",
            tabsLocation = "left",
            className = ""
        } = this.props;

        const { activeTabPosition } = this.state;

        return (
            <div className={classnames("tabs-container", "removeTopBorder", "m-3", className)}>
                <div className={"tabs-" + tabsLocation}>
                    <div className="nav nav-tabs " style={{display:"grid"}}>
                        {
                            tabTitles.map((titleText, titleIndex) => {
                                return <TabTitle
                                    key={"tabtitle-" + titleIndex}
                                    tabTitleTextAlignment={tabTitleTextAlignment}
                                    isActive={activeTabPosition === titleIndex}
                                    text={titleText}
                                    onClick={() => this.setTabActive(titleIndex)}
                                />
                            })
                        }
                    </div>
                    <div className="tab-content">
                        {
                            tabPanels.map((tabContent, contentIndex) => {
                                return <TabContent
                                    key={"tabcontent-" + contentIndex}
                                    isActive={activeTabPosition === contentIndex}
                                    content={tabContent}
                                />
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

TabbedPanel.propTypes = {
    tabsLocation: PropTypes.string,
    tabTitleTextAlignment: PropTypes.string,
    tabTitles: PropTypes.array,
    tabPanels: PropTypes.array
};

export default TabbedPanel;